var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProductSuccess = function SvgProductSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5166 34.6167H113.483V104.383H25.5166V34.6167Z",
    fill: "#CDF9F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 70C0 80.3543 2.24838 90.1831 6.28265 99.026C13.1795 114.143 25.2972 126.374 40.3288 133.42C43.0515 134.695 45.8713 135.8 48.7744 136.72C52.0396 137.763 55.4085 138.566 58.866 139.117C58.8799 139.12 58.8969 139.123 58.9119 139.123C60.6081 139.394 62.3203 139.603 64.0538 139.749C64.4234 139.78 64.794 139.809 65.1657 139.834C65.6891 139.869 66.2146 139.9 66.7433 139.923C67.8232 139.974 68.9084 140 70 140C71.1205 140 72.2313 139.974 73.3368 139.92C73.8367 139.897 74.3376 139.869 74.8375 139.831C75.2113 139.806 75.583 139.78 75.9547 139.749C77.7289 139.601 79.4859 139.383 81.2195 139.103C82.0483 138.968 82.874 138.823 83.6911 138.66C87.2372 137.957 90.683 136.989 94.0112 135.771C95.9402 135.069 97.8287 134.282 99.6744 133.417C100.302 133.122 100.928 132.817 101.549 132.5C103.143 131.694 104.7 130.828 106.22 129.905C113.834 125.294 120.497 119.271 125.852 112.2C129.066 107.954 131.805 103.332 133.994 98.4055C137.854 89.726 140 80.114 140 70C140 31.3396 108.66 0 70 0C31.3396 0 0 31.3396 0 70Z",
    fill: "#FFE152"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5835 40.6831H107.417V98.3164H31.5835V40.6831Z",
    fill: "#7FCAC9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0669 48.2666H33.1002V84.6666H30.0669V48.2666Z",
    fill: "#7FCAC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.167 48.2666H42.2003V84.6666H39.167V48.2666Z",
    fill: "#7FCAC9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2002 48.2666H45.2335V84.6666H42.2002V48.2666Z",
    fill: "#7FCAC9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2671 48.2666H51.3004V84.6666H48.2671V48.2666Z",
    fill: "#7FCAC9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3667 48.2666H60.4V84.6666H57.3667V48.2666Z",
    fill: "#7FCAC9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4004 48.2666H63.4337V84.6666H60.4004V48.2666Z",
    fill: "#7FCAC9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4668 48.2666H69.5001V84.6666H66.4668V48.2666Z",
    fill: "#7FCAC9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.9 48.2666H108.934V84.6666H105.9V48.2666Z",
    fill: "#7FCAC9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8003 48.2666H99.8336V84.6666H96.8003V48.2666Z",
    fill: "#7FCAC9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7671 48.2666H96.8004V84.6666H93.7671V48.2666Z",
    fill: "#7FCAC9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7002 48.2666H90.7335V84.6666H87.7002V48.2666Z",
    fill: "#7FCAC9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6001 48.2666H81.6334V84.6666H78.6001V48.2666Z",
    fill: "#7FCAC9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 48.2666H72.5333V84.6666H69.5V48.2666Z",
    fill: "#7FCAC9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1338 87.6997H39.1671V90.733H36.1338V87.6997Z",
    fill: "#7FCAC9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2002 87.6997H45.2335V90.733H42.2002V87.6997Z",
    fill: "#7FCAC9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2671 87.6997H51.3004V90.733H48.2671V87.6997Z",
    fill: "#7FCAC9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3335 87.6997H57.3668V90.733H54.3335V87.6997Z",
    fill: "#7FCAC9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0669 87.6997H33.1002V90.733H30.0669V87.6997Z",
    fill: "#7FCAC9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4004 87.6997H63.4337V90.733H60.4004V87.6997Z",
    fill: "#7FCAC9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4668 87.6997H69.5001V90.733H66.4668V87.6997Z",
    fill: "#7FCAC9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5337 87.6997H75.567V90.733H72.5337V87.6997Z",
    fill: "#7FCAC9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6001 87.6997H81.6334V90.733H78.6001V87.6997Z",
    fill: "#7FCAC9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M84.667 87.6997H87.7003V90.733H84.667V87.6997Z",
    fill: "#7FCAC9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7334 87.6997H93.7667V90.733H90.7334V87.6997Z",
    fill: "#7FCAC9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8003 87.6997H99.8336V90.733H96.8003V87.6997Z",
    fill: "#7FCAC9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2002 87.6997H45.2335V90.733H42.2002V87.6997Z",
    fill: "#7FCAC9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2671 87.6997H51.3004V90.733H48.2671V87.6997Z",
    fill: "#7FCAC9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3335 87.6997H57.3668V90.733H54.3335V87.6997Z",
    fill: "#7FCAC9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4004 87.6997H63.4337V90.733H60.4004V87.6997Z",
    fill: "#7FCAC9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1338 87.6997H39.1671V90.733H36.1338V87.6997Z",
    fill: "#7FCAC9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4668 87.6997H69.5001V90.733H66.4668V87.6997Z",
    fill: "#7FCAC9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5337 87.6997H75.567V90.733H72.5337V87.6997Z",
    fill: "#7FCAC9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6001 87.6997H81.6334V90.733H78.6001V87.6997Z",
    fill: "#7FCAC9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M84.667 87.6997H87.7003V90.733H84.667V87.6997Z",
    fill: "#7FCAC9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7334 87.6997H93.7667V90.733H90.7334V87.6997Z",
    fill: "#7FCAC9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8003 87.6997H99.8336V90.733H96.8003V87.6997Z",
    fill: "#7FCAC9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M102.867 87.6997H105.9V90.733H102.867V87.6997Z",
    fill: "#7FCAC9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0333 45.2334H24V33.1001H36.1333V36.1334H27.0333V45.2334Z",
    fill: "#195C85"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M115 45.2334H111.967V36.1334H102.867V33.1001H115V45.2334Z",
    fill: "#195C85"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M115 105.9H102.867V102.867H111.967V93.7666H115V105.9Z",
    fill: "#195C85"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1333 105.9H24V93.7666H27.0333V102.867H36.1333V105.9Z",
    fill: "#195C85"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1336 99.8333H30.0669V93.7666H33.1002V96.7999H36.1336V99.8333Z",
    fill: "#195C85"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1002 45.2337H30.0669V39.167H36.1336V42.2003H33.1002V45.2337Z",
    fill: "#195C85"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M108.933 45.2337H105.9V42.2003H102.867V39.167H108.933V45.2337Z",
    fill: "#195C85"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M108.933 99.8333H102.867V96.7999H105.9V93.7666H108.933V99.8333Z",
    fill: "#195C85"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1665 39.167H99.8332V42.2003H39.1665V39.167Z",
    fill: "#195C85"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1665 96.8003H99.8332V99.8336H39.1665V96.8003Z",
    fill: "#195C85"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0669 48.2666H33.1002V84.6666H30.0669V48.2666Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1665 48.2666H45.2332V84.6666H39.1665V48.2666Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2666 48.2666H51.2999V84.6666H48.2666V48.2666Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3667 48.2666H63.4334V84.6666H57.3667V48.2666Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4668 48.2666H72.5335V84.6666H66.4668V48.2666Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M105.9 48.2666H108.933V84.6666H105.9V48.2666Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7666 48.2666H99.8333V84.6666H93.7666V48.2666Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7002 48.2666H90.7335V84.6666H87.7002V48.2666Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6001 48.2666H81.6334V84.6666H78.6001V48.2666Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0669 87.7002H33.1002V90.7335H30.0669V87.7002Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2002 87.7002H45.2335V90.7335H42.2002V87.7002Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2666 87.7002H51.2999V90.7335H48.2666V87.7002Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3335 87.7002H57.3668V90.7335H54.3335V87.7002Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3999 87.7002H63.4332V90.7335H60.3999V87.7002Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1333 87.7002H39.1666V90.7335H36.1333V87.7002Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4668 87.7002H69.5001V90.7335H66.4668V87.7002Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5332 87.7002H75.5665V90.7335H72.5332V87.7002Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6001 87.7002H81.6334V90.7335H78.6001V87.7002Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6665 87.7002H87.6998V90.7335H84.6665V87.7002Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7334 87.7002H93.7667V90.7335H90.7334V87.7002Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7998 87.7002H99.8331V90.7335H96.7998V87.7002Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M102.867 87.7002H105.9V90.7335H102.867V87.7002Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0333 36.1334H36.1333V33.1001H24V45.2334H27.0333V36.1334Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M102.867 36.1334H111.967V45.2334H115V33.1001H102.867V36.1334Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M111.967 102.867H102.867V105.9H115V93.7666H111.967V102.867Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1333 102.867H27.0333V93.7666H24V105.9H36.1333V102.867Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0669 99.8333H36.1336V96.7999H33.1002V93.7666H30.0669V99.8333Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1336 39.1665H30.0669V45.2332H33.1002V42.1998H36.1336V39.1665Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M108.933 39.1665H102.867V42.1998H105.9V45.2332H108.933V39.1665Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M102.867 99.8333H108.933V93.7666H105.9V96.7999H102.867V99.8333Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1665 39.1665H99.8332V42.1998H39.1665V39.1665Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1665 96.7998H99.8332V99.8331H39.1665V96.7998Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M116.666 138.833C129.553 138.833 140 128.386 140 115.5C140 102.613 129.553 92.1665 116.666 92.1665C103.78 92.1665 93.333 102.613 93.333 115.5C93.333 128.386 103.78 138.833 116.666 138.833Z",
    fill: "#00E59E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M110.704 126.026L122.702 138.024C132.639 135.374 140 126.32 140 115.5C140 115.279 140 115.058 140 114.837L130.578 106.152L110.704 126.026Z",
    fill: "#00D492"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M117.254 120.726C118.285 121.757 118.285 123.523 117.254 124.554L115.12 126.688C114.089 127.719 112.323 127.719 111.292 126.688L101.944 117.267C100.914 116.236 100.914 114.47 101.944 113.439L104.079 111.305C105.109 110.274 106.876 110.274 107.906 111.305L117.254 120.726Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M125.425 104.459C126.455 103.428 128.222 103.428 129.252 104.459L131.387 106.593C132.417 107.624 132.417 109.391 131.387 110.421L115.194 126.541C114.163 127.571 112.396 127.571 111.366 126.541L109.231 124.406C108.201 123.376 108.201 121.609 109.231 120.579L125.425 104.459Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product-success.387d9eec.svg";
export { ForwardRef as ReactComponent };